import React from 'react'

const Year = ({data, style, tabIndex}) => {

    return(
        <h3 className={`homepage--timeline-yearwrap`} {...tabIndex} {...style}>{data.year}</h3>
    )
}

export default Year